import { StASymmetricCryptographyProvider } from "./StASymmetricCryptographyProvider";
import { StCryptographyProvider } from "./StCryptographyProvider";
import { StCryptographyType } from "./StCryptographyType";
import { StSymmetricCryptographyProvider } from "./StSymmetricCryptographyProvider";

export class StCryptographyProviderFactory {
  static create(method: StCryptographyType): StCryptographyProvider {
    switch (method) {
      case StCryptographyType.ASYMMETRIC:
        return new StASymmetricCryptographyProvider();
      case StCryptographyType.SYMMETRIC:
        return new StSymmetricCryptographyProvider();
    }
  }
}
